const lb = angular.module('app.lb', [require('angular-auth0')]);

lb.config([
  'angularAuth0Provider',
  (angularAuth0Provider) => {
    angularAuth0Provider.init({
      clientID: window.Auth0ClientId,
      domain: window.Auth0Domain,
      responseType: 'token id_token',
      audience: window.Auth0ApiIdentifier,
      scope: window.Auth0Scope,
      redirectUri: window.Auth0Callback,
    });
  },
]);

lb.run([
  '$rootScope',
  '$state',
  'AUTH_EVENTS',
  ($rootScope, $state, AUTH_EVENTS) =>
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
      $state.go('landing.login');
    }),
]);

export default lb;



// WEBPACK FOOTER //
// ./src/appSpecificImports/index.lb.js